export function live(field, fallback = "") {
  if (!field || typeof field !== "object") return field || fallback;
  return field.published || field.configured || field.detected || fallback;
}

export function bandColor(score) {
  if (score == null) return "#64748B";
  if (score >= 85) return "#10B981";
  if (score >= 70) return "#3B82F6";
  if (score >= 50) return "#F59E0B";
  return "#EF4444";
}

export function TripleHint({ field }) {
  if (!field) return null;
  return (
    <div className="grid grid-cols-3 gap-2 text-[10px] text-white/45 mt-1">
      <div><span className="uppercase tracking-wider text-white/30">Detected</span><div className="text-white/70 truncate">{field.detected || "—"}</div></div>
      <div><span className="uppercase tracking-wider text-white/30">Draft</span><div className="text-cyan-200/80 truncate">{field.configured || "—"}</div></div>
      <div><span className="uppercase tracking-wider text-white/30">Published</span><div className="text-emerald-300/80 truncate">{field.published || "not published"}</div></div>
    </div>
  );
}

export function hasUnpublishedChanges(page) {
  const check = (field) => {
    if (!field || typeof field !== "object") return false;
    const c = field.configured || "";
    const p = field.published || "";
    return Boolean(c && c !== p);
  };
  const seo = page?.seo || {};
  const technical = page?.technical || {};
  const social = page?.social || {};
  const og = social.open_graph || {};
  const tw = social.twitter || {};
  const socialDirty = Boolean(
    (og.title || og.description || og.image || og.url) && page?.publish_state !== "published",
  ) || Boolean((tw.title || tw.image) && page?.publish_state !== "published");
  return (
    check(seo.title)
    || check(seo.description)
    || check(technical.canonical)
    || check(technical.robots)
    || check(page?.schema)
    || socialDirty
  );
}

export const PUBLISH_REBUILD_HINT =
  "API is live now. Rebuild & deploy the website for view-source / crawler first-paint HTML. Robots & sitemap update without rebuild.";

export function publishRebuildHint(measurement) {
  const hook = measurement?.deploy_hook;
  if (hook?.configured && hook?.enabled !== false) {
    return "API is live now. Cloudflare Pages rebuild is triggered automatically on publish (deploy hook). Robots, sitemap, llms.txt update without rebuild.";
  }
  return PUBLISH_REBUILD_HINT;
}
